import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { AdHocSendOption } from '../AdHocBillModal.types';
import { ScheduleDialog } from '../ConfirmationDialogs/ScheduleDialog';
import { SendByEmailDialog } from '../ConfirmationDialogs/SendByEmailDialog';
import { ShareByLinkDialog } from '../ConfirmationDialogs/ShareByLinkDialog';
import { useAdHocApprovalLink } from './useAdHocApprovalLink';
const buyerName = (relationship)=>[
        relationship.buyer.firstName,
        relationship.buyer.lastName
    ].filter((part)=>part != null && part.length > 0).join(' ');
export const useAdHocSendActions = (param)=>{
    let { relationship, relationshipId, form, coverCreditCardFees, submitAdHoc, dismissModal, invoiceIssuedTimeoutMs } = param;
    const { showModal, showSuccessToast } = useOverlayContext();
    const { startListening, resolveApprovalLink } = useAdHocApprovalLink({
        invoiceIssuedTimeoutMs
    });
    const { t: commonTexts } = useLocaleKeys('common');
    const history = useHistory();
    const contactName = buyerName(relationship);
    const { isFutureIssueDate } = form;
    const openSendDialog = ()=>{
        const DialogComponent = isFutureIssueDate ? ScheduleDialog : SendByEmailDialog;
        showModal({
            biName: 'dialog_component_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal: dismissDialog } = param;
                return /*#__PURE__*/ _jsx(DialogComponent, {
                    companyName: relationship.customer.name,
                    contactName: contactName,
                    email: relationship.buyer.email,
                    coverCreditCardFees: coverCreditCardFees,
                    onBack: dismissDialog,
                    onConfirm: ()=>submitAdHoc(AdHocSendOption.SendByEmail, dismissDialog)
                });
            }
        });
    };
    const openShareByLinkDialog = ()=>{
        showModal({
            biName: 'share_by_link_dialog_modal',
            closeOnClickOutside: false,
            closeOnEscapeKey: false,
            content: (param)=>{
                let { dismissModal: dismissDialog } = param;
                return /*#__PURE__*/ _jsx(ShareByLinkDialog, {
                    companyName: relationship.customer.name,
                    contactName: contactName,
                    email: relationship.buyer.email,
                    onCancel: dismissDialog,
                    onGenerateLink: async ()=>{
                        const invoiceIdPromise = startListening(relationshipId);
                        const success = await submitAdHoc(AdHocSendOption.ShareByLink);
                        if (!success) {
                            invoiceIdPromise.catch(()=>undefined);
                            return {
                                success: false
                            };
                        }
                        try {
                            const linkUrl = await resolveApprovalLink(invoiceIdPromise);
                            return {
                                success: true,
                                linkUrl
                            };
                        } catch (unused) {
                            return {
                                success: true,
                                linkUrl: null
                            };
                        }
                    },
                    onClose: ()=>{
                        dismissDialog();
                        showSuccessToast(commonTexts.toasts.chargesSuccessfullyCreated(), 'ad-hoc-bill-share-link-success-toast');
                        history.push(routes.globalBillingHubRoutes({
                            clientId: relationship.customer.id,
                            relationshipId
                        }).invoices);
                        dismissModal();
                    }
                });
            }
        });
    };
    const validateEmailFields = ()=>{
        const subjectEmpty = form.getValues('emailSubject').trim().length === 0;
        const contentEmpty = form.getValues('emailContent').trim().length === 0;
        if (subjectEmpty) form.setError('emailSubject', {
            type: 'required'
        });
        if (contentEmpty) form.setError('emailContent', {
            type: 'required'
        });
        return !subjectEmpty && !contentEmpty;
    };
    const handleSendOption = (option)=>{
        if (option === AdHocSendOption.SendByEmail) {
            if (!validateEmailFields()) return;
            form.handleSubmit(()=>openSendDialog())();
            return;
        }
        form.clearErrors([
            'emailSubject',
            'emailContent'
        ]);
        if (option === AdHocSendOption.ShareByLink) {
            form.handleSubmit(()=>openShareByLinkDialog())();
            return;
        }
        form.handleSubmit(()=>submitAdHoc(option))();
    };
    return {
        handleSendOption
    };
};
